<div class="filter" ngModelGroup="personalGroup" #personal="ngModelGroup">
  <app-filter-item [title]="'Personal'" [value]="personalValue" [clearFilter]="clearFilter()">
      <app-autocomplete
        name="officer"
        [placeholder]="'John Smith'"
        [(ngModel)]="personalGroup.officer"
        [filter]="filter"
      />
  </app-filter-item>
</div>
